import { useTranslation } from "react-i18next";

export default function AboutSection() {
  const { t } = useTranslation();

  const values = [
    {
      icon: "ri-heart-pulse-line",
      titleKey: "about.value1Title",
      descKey: "about.value1Desc",
    },
    {
      icon: "ri-shield-check-line",
      titleKey: "about.value2Title",
      descKey: "about.value2Desc",
    },
    {
      icon: "ri-map-pin-2-line",
      titleKey: "about.value3Title",
      descKey: "about.value3Desc",
    },
  ];

  return (
    <section id="about" className="bg-[#F8F7F4] py-32 px-8">
      <div className="max-w-6xl mx-auto">
        {/* Section header */}
        <div className="flex items-center gap-4 mb-6">
          <div className="w-8 h-px bg-[#3D6B5A]" />
          <span
            className="text-[11px] tracking-[0.25em] uppercase text-[#3D6B5A] font-medium"
            style={{ fontFamily: "'DM Sans', sans-serif" }}
          >
            {t("about.badge")}
          </span>
        </div>

        <div className="grid md:grid-cols-2 gap-16 items-center mb-24">
          {/* Text */}
          <div>
            <h2
              className="text-5xl font-light text-[#1A1A18] leading-tight mb-8"
              style={{ fontFamily: "'Cormorant Garamond', serif" }}
            >
              {t("about.title1")}<br />
              <em className="italic">{t("about.title2")}</em>
            </h2>
            <p
              className="text-[#6B6B65] text-[15px] leading-relaxed mb-6 font-light"
              style={{ fontFamily: "'DM Sans', sans-serif" }}
            >
              {t("about.p1")}
            </p>
            <p
              className="text-[#6B6B65] text-[15px] leading-relaxed font-light"
              style={{ fontFamily: "'DM Sans', sans-serif" }}
            >
              {t("about.p2")}
            </p>
          </div>

          {/* Image */}
          <div className="relative">
            <div className="w-full h-[420px] rounded-lg overflow-hidden">
              <img
                src="https://public.readdy.ai/ai/img_res/1464ce7d888431f50ede2d1dea859ae5.jpg"
                alt="Modern examination room"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="absolute -bottom-4 -left-4 w-32 h-32 bg-[#EBF2EE] rounded-lg -z-10" />
          </div>
        </div>

        {/* Value pillars */}
        <div className="grid md:grid-cols-3 gap-8">
          {values.map((v) => (
            <div
              key={v.titleKey}
              className="bg-white rounded-lg p-8 border border-[#E8E4DC] hover:border-[#C8D8D3] transition-colors duration-300"
            >
              <div className="w-10 h-10 flex items-center justify-center mb-5">
                <i className={`${v.icon} text-[#3D6B5A] text-2xl`} />
              </div>
              <h3
                className="text-xl font-light text-[#1A1A18] mb-3"
                style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: "22px" }}
              >
                {t(v.titleKey)}
              </h3>
              <p
                className="text-[#6B6B65] text-[14px] leading-relaxed font-light"
                style={{ fontFamily: "'DM Sans', sans-serif" }}
              >
                {t(v.descKey)}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
